/* tslint:disable */
type FormState =
  'UNPROCESSED' |
  'MANUAL_CHECK' |
  'PROCESSED' |
  'DISCARD' |
  'TBD' |
  'DUPLICATE';
module FormState {
  export const UNPROCESSED: FormState = 'UNPROCESSED';
  export const MANUAL_CHECK: FormState = 'MANUAL_CHECK';
  export const PROCESSED: FormState = 'PROCESSED';
  export const DISCARD: FormState = 'DISCARD';
  export const TBD: FormState = 'TBD';
  export const DUPLICATE: FormState = 'DUPLICATE';
  export function values(): FormState[] {
    return [
      UNPROCESSED,
      MANUAL_CHECK,
      PROCESSED,
      DISCARD,
      TBD,
      DUPLICATE
    ];
  }
}

export { FormState }